import { render, staticRenderFns } from "./SlideOptionsInputV2.vue?vue&type=template&id=d36a260c&scoped=true&"
import script from "./SlideOptionsInputV2.vue?vue&type=script&lang=js&"
export * from "./SlideOptionsInputV2.vue?vue&type=script&lang=js&"
import style0 from "./SlideOptionsInputV2.vue?vue&type=style&index=0&id=d36a260c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36a260c",
  null
  
)

export default component.exports